<template>
<div class="home">
    <div class="hero-section">
        <div class="hero-bg-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-7">
                    <div class="hero-content">
                        <div class="hero-badge">AP Computer Science A</div>
                        <h1 class="hero-title">From ZERO To HERO</h1>
                        <p class="hero-subtitle">通往编程大门的成功之路</p>
                        
                        <div class="hero-features">
                          <div class="feature-item">
                            <i class="fas fa-check-circle"></i>
                            <span>专业课程体系</span>
                          </div>
                          <div class="feature-item">
                            <i class="fas fa-check-circle"></i>
                            <span>在线编程练习</span>
                          </div>
                          <div class="feature-item">
                            <i class="fas fa-check-circle"></i>
                            <span>真题模拟考试</span>
                          </div>
                        </div>

                        <div class="hero-actions">
                            <button @click="toCenter" v-if="userInfo != null" class="btn btn-primary-custom">
                              <i class="fas fa-rocket"></i> 进入学习
                            </button>
                            <button @click="login" v-if="userInfo == null" class="btn btn-primary-custom">
                              <i class="fas fa-sign-in-alt"></i> 登录学习
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="hero-image">
                      <img src="/images/back3.png" alt="AP Programming"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container">
        <section class="features-section">
            <div class="section-header">
              <h2 class="section-title">课程体系三大支柱</h2>
              <p class="section-desc">系统化学习路径，助力AP考试高分突破</p>
            </div>
            <div class="row row-cols-1 row-cols-md-3 g-4">
              <div class="col">
                <div class="feature-card">
                  <div class="feature-icon learn">
                    <i class="fas fa-book-open"></i>
                  </div>
                  <h3 class="feature-title">学 · 深度学习系统</h3>
                  <ul class="feature-list">
                    <li><i class="fas fa-check"></i> 一级推进：Java思维，拒绝幼稚化</li>
                    <li><i class="fas fa-check"></i> 二级推进：知识网络，解题反射</li>
                    <li><i class="fas fa-check"></i> 三级推进：考场重塑，肌肉记忆</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="feature-card">
                  <div class="feature-icon practice">
                    <i class="fas fa-code"></i>
                  </div>
                  <h3 class="feature-title">练 · 多维熔炼系统</h3>
                  <ul class="feature-list">
                    <li><i class="fas fa-fire"></i> 错误熔炼：Bug锻造，代码免疫</li>
                    <li><i class="fas fa-fire"></i> 心流熔炼：AI护航，最佳状态</li>
                    <li><i class="fas fa-fire"></i> 竞技熔炼：开发者对决，突破极限</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="feature-card">
                  <div class="feature-icon exam">
                    <i class="fas fa-trophy"></i>
                  </div>
                  <h3 class="feature-title">考 · 精准评估系统</h3>
                  <ul class="feature-list">
                    <li><i class="fas fa-search"></i> 知识棱镜：精准定位薄弱点</li>
                    <li><i class="fas fa-search"></i> 思维棱镜：透视解题策略</li>
                    <li><i class="fas fa-search"></i> 行为棱镜：诊断考场习惯</li>
                  </ul>
                </div>
              </div>
            </div>
        </section>

        <section class="pricing-section">
            <div class="section-header">
              <h2 class="section-title">课程套餐</h2>
              <p class="section-desc">选择适合你的学习方案</p>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-4 mb-4">
                <div class="pricing-card">
                  <div class="pricing-header">
                    <h4>基础启航</h4>
                    <div class="pricing-badge">入门首选</div>
                  </div>
                  <div class="pricing-body">
                    <ul class="pricing-features">
                      <li><i class="fas fa-check"></i> 1 对 1 精讲</li>
                      <li><i class="fas fa-check"></i> 基础题库练习</li>
                      <li><i class="fas fa-check"></i> 3 次模拟考试</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-4">
                <div class="pricing-card featured">
                  <div class="pricing-header">
                    <h4>强化提高</h4>
                    <div class="pricing-badge">热门推荐</div>
                  </div>
                  <div class="pricing-body">
                    <ul class="pricing-features">
                      <li><i class="fas fa-check"></i> 1 对 1 精讲</li>
                      <li><i class="fas fa-check"></i> 进阶题库 + 解析</li>
                      <li><i class="fas fa-check"></i> 3 次模拟考试</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-4">
                <div class="pricing-card">
                  <div class="pricing-header">
                    <h4>考前冲刺</h4>
                    <div class="pricing-badge">高分保障</div>
                  </div>
                  <div class="pricing-body">
                    <ul class="pricing-features">
                      <li><i class="fas fa-check"></i> 1 对 1 练习冲刺</li>
                      <li><i class="fas fa-check"></i> 在线答疑</li>
                      <li><i class="fas fa-check"></i> 考前密训</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
        </section>
    </div>

    <bottom></bottom>
</div>
  </template>
  
  <script>
  import bottom from '../components/bottom.vue';
  export default {
    name: "HomePage",
    data(){
      return{
        userInfo:{}
      }
    },
    components:{
        bottom
    },
    mounted(){
        var user = localStorage.getItem('user');
        if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
            this.userInfo = userObj;
        }
        else{
          this.userInfo = null;
        }
    },
    methods:{
      login(){
        document.getElementById("login-a").click();
      },
      toCenter(){
        this.$router.push('center');
      },
        jump(url){
            location.href=url;
        },
        sendCode(){

        }
    }
  };
  </script>
  
  <style lang="scss">
@import '@/styles/variables.scss';

.home {
  background: $bg-primary;
  min-height: 100vh;
}

.hero-section {
  position: relative;
  background: linear-gradient(135deg, $primary-dark 0%, $primary-color 50%, $primary-light 100%);
  padding: 120px 0 80px;
  margin-top: 56px;
  overflow: hidden;
  
  .hero-bg-shapes {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
    
    .shape {
      position: absolute;
      border-radius: 50%;
      opacity: 0.1;
      
      &.shape-1 {
        width: 400px;
        height: 400px;
        background: white;
        top: -100px;
        right: -100px;
        animation: float 8s ease-in-out infinite;
      }
      
      &.shape-2 {
        width: 300px;
        height: 300px;
        background: white;
        bottom: -50px;
        left: -50px;
        animation: float 6s ease-in-out infinite reverse;
      }
      
      &.shape-3 {
        width: 200px;
        height: 200px;
        background: white;
        top: 50%;
        left: 50%;
        animation: float 10s ease-in-out infinite;
      }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(10deg);
  }
}

.hero-content {
  position: relative;
  z-index: 1;
  color: white;
  text-align: left;
  
  .hero-badge {
    display: inline-block;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    padding: 8px 20px;
    border-radius: 30px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
  }
  
  .hero-title {
    font-size: 52px;
    font-weight: 800;
    margin-bottom: 16px;
    line-height: 1.2;
    color: #ffffff;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .hero-subtitle {
    font-size: 22px;
    opacity: 0.95;
    margin-bottom: 30px;
    font-weight: 400;
  }
  
  .hero-features {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 35px;
    
    .feature-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 15px;
      font-weight: 500;
      
      i {
        color: $accent-light;
      }
    }
  }
  
  .hero-actions {
    display: flex;
    gap: 16px;
    
    .btn-primary-custom {
      background: white;
      color: $primary-color;
      border: none;
      padding: 14px 32px;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
      }
      
      i {
        font-size: 14px;
      }
    }
  }
}

.hero-image {
  position: relative;
  z-index: 1;
  text-align: center;
  
  img {
    max-width: 100%;
    height: auto;
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2));
    animation: floatImage 6s ease-in-out infinite;
  }
}

@keyframes floatImage {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

.features-section, .pricing-section {
  padding: 80px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
  
  .section-title {
    font-size: 32px;
    font-weight: 700;
    color: $text-primary;
    margin-bottom: 12px;
  }
  
  .section-desc {
    font-size: 16px;
    color: $text-secondary;
  }
}

.feature-card {
  background: white;
  border-radius: 20px;
  padding: 35px 30px;
  height: 100%;
  box-shadow: $shadow-card;
  border: 1px solid $border-light;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: $primary-gradient;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: $shadow-card-hover;
    border-color: rgba($primary-color, 0.2);
    
    &::before {
      opacity: 1;
    }
  }
  
  .feature-icon {
    width: 70px;
    height: 70px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    font-size: 28px;
    
    &.learn {
      background: linear-gradient(135deg, rgba($primary-color, 0.1) 0%, rgba($primary-light, 0.2) 100%);
      color: $primary-color;
    }
    
    &.practice {
      background: linear-gradient(135deg, rgba($secondary-color, 0.1) 0%, rgba($secondary-light, 0.2) 100%);
      color: $secondary-color;
    }
    
    &.exam {
      background: linear-gradient(135deg, rgba($accent-color, 0.1) 0%, rgba($accent-light, 0.2) 100%);
      color: $accent-color;
    }
  }
  
  .feature-title {
    font-size: 20px;
    font-weight: 700;
    color: $text-primary;
    margin-bottom: 20px;
  }
  
  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 0;
      color: $text-secondary;
      font-size: 14px;
      border-bottom: 1px solid $border-light;
      
      &:last-child {
        border-bottom: none;
      }
      
      i {
        color: $primary-color;
        font-size: 12px;
      }
    }
  }
}

.pricing-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: $shadow-card;
  border: 1px solid $border-light;
  transition: all 0.4s ease;
  height: 100%;
  
  &.featured {
    border: 2px solid $primary-color;
    transform: scale(1.02);
    
    .pricing-header {
      background: $primary-gradient;
      color: white;
      
      .pricing-badge {
        background: rgba(255, 255, 255, 0.2);
        color: white;
      }
    }
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: $shadow-card-hover;
  }
  
  .pricing-header {
    background: $bg-secondary;
    padding: 30px;
    text-align: center;
    position: relative;
    
    h4 {
      font-size: 22px;
      font-weight: 700;
      color: $text-primary;
      margin: 0;
    }
    
    .pricing-badge {
      position: absolute;
      top: 15px;
      right: 15px;
      background: rgba($primary-color, 0.1);
      color: $primary-color;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
    }
  }
  
  .pricing-body {
    padding: 30px;
    
    .pricing-features {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        color: $text-secondary;
        font-size: 15px;
        border-bottom: 1px solid $border-light;
        
        &:last-child {
          border-bottom: none;
        }
        
        i {
          color: $success-color;
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 80px 0 60px;
    
    .hero-content {
      text-align: center;
      
      .hero-title {
        font-size: 36px;
      }
      
      .hero-subtitle {
        font-size: 18px;
      }
      
      .hero-features {
        justify-content: center;
      }
      
      .hero-actions {
        justify-content: center;
      }
    }
    
    .hero-image {
      margin-top: 40px;
      
      img {
        max-width: 280px;
      }
    }
  }
  
  .section-header .section-title {
    font-size: 26px;
  }
  
  .pricing-card.featured {
    transform: scale(1);
  }
}
  </style>
